import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
); 

// PWA: register service worker.
// In production this can help offline support, but during development it can
// cause confusing stale UI issues. We also disable updates while caching
// unless the SW already has a new version.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    // Avoid SW caching behavior during local development.
    if (process.env.NODE_ENV === "development") return;

    navigator.serviceWorker
      .register("/service-worker.js", { updateViaCache: "none" })
      .catch(() => {
        // Non-fatal: install still depends on manifest.
      });
  });
}

root.render(
  <React.StrictMode>
    <App />  
  </React.StrictMode>,
);
